module.exports = __webpack_public_path__ + "img/logo-bbva-openplatform.12494b95.png";